<template>
  <div id="dialog">
    <el-dialog
      :title="title"
      :visible.sync="customDialog.visible"
      :show-close="customDialog.isShowClose"
      :close-on-click-modal="customDialog.isClickModal"
      :close-on-press-escape="customDialog.isPressEscape"
      @close="$emit('handleClose')"
    >
      <slot name="dialogCon"></slot>
      <div slot="footer" class="dialog-footer">
        <slot name="dialogFoot"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    customDialog: {
      required: false,
      default: function () {
        return {
          visible: false,
          isShowClose: true,
          isClickModal: true,
          isPressEscape: true
        }
      }
    },
    title: {
      required: false,
      default: function () {
        return ''
      }
    }
  }
}
</script>
